import React, {useEffect, useState} from 'react';
import {FilterDemand} from "../types/filterDemand";
import {useTranslation} from "../hooks/useTranslation";

type DownloadsFilterProps = {
    demand : FilterDemand
    setDemand : (demand: FilterDemand) => void
}

function DownloadsFilterOptions({demand, setDemand} : DownloadsFilterProps) {

    const translate = useTranslation();

    const [isChecked, setIsChecked] = useState({option1: false, option2: false});


    useEffect(() => {
        setDemand({...demand, option1: isChecked.option1 ? 1 : 0, option2: isChecked.option2 ? 1 : 0})
    }, [isChecked]);

    const handleChange = (e: any) => {
        const target = e.target;
        const value = target.checked;
        const name = target.name;

        setIsChecked({
            option1: (name === 'option1' ? value : isChecked.option1),
            option2: (name === 'option2' ? value : isChecked.option2)
        });
    };

    return (
        <div className='downloadsOverview__filter--options'>
            <div className='downloadsOverview__filter--options-item custom-control custom-checkbox'>
                <input
                    type="checkbox"
                    name="option1"
                    id="option1"
                    className="custom-control-input"
                    checked={isChecked.option1}
                    onChange={handleChange}
                />

                <label className='custom-control-label' htmlFor='option1' >{translate('option1')}</label>
            </div>

            <div className='downloadsOverview__filter--options-item custom-control custom-checkbox'>
                <input
                    type="checkbox"
                    name="option2"
                    id="option2"
                    className="custom-control-input"
                    checked={isChecked.option2}
                    onChange={handleChange}
                />
                <label className='custom-control-label' htmlFor='option2' >{translate('option2')}</label>
            </div>
        </div>
    );
}

export default DownloadsFilterOptions;
